import React, { Component } from 'react';

import PropTypes from 'prop-types';

import poweredByLoft from '../../../assets/src/svg/powered-by-loft.svg';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;

    return (
      <div className="footer">
        <span>
          Copyright &copy; {new Date().getFullYear()}
          &nbsp;<a href="https://www.realpage.com">Realpage</a>. All rights reserved.
        </span>
        <img src={poweredByLoft} alt="Powered by LOFT" className="footerPowered" />
      </div>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
